// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { ListItemFactory } from "@app/shared";
import { DepartmentGroupDto } from "@app/catalog";

export class DepartmentGroupModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public isChecked: WritableSignal<boolean>;

    constructor()
    {
        this.name = signal<string>(null);
        this.thumbnailUrl = signal<string>(null);
        this.isChecked = signal<boolean>(false);
    }

    public select(val: boolean) {
        this.isChecked.set(val ? true : false);
    }

    public handleImageError() {
        this.thumbnailUrl.set(`/assets/images/1.png`);
      }

    public static fromDto(dto: DepartmentGroupDto)
    {
        let status = new DepartmentGroupModel();

        status.id = dto.id;
        status.name.set(dto.name);
        status.thumbnailUrl.set(dto.thumbnailUrl);
                
        return status;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<DepartmentGroupModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<DepartmentGroupModel>(this.name, this.id, this, selected);    

}
